<template lang="pug" src="./edit-dialog.pug"> </template>
<style lang="scss" src="./edit-dialog.scss" scoped> </style>

<script>
import uploadCsv from '@/components/upload-csv';
import { mapState } from 'vuex';
import { getFormData } from '@/utils/helpers';
import config from '../../../../../../config.json';

export default {
    components: {
        'v-upload-csv': uploadCsv,
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        editedPhotoReport: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        formData: null,
        useCsv: config.photoReport.useCsv
    }),
    computed: {
        ...mapState({
            reasons: (state) => state.photoReasons.reasons
        }),
        editDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        closeEditDialog() {
            this.$emit('onClose');
            this.editDialog = false;
        },

        editPhotoReport() {
            this.formData = getFormData({
                requestName: this.editedPhotoReport.requestName
            });

            this.$store.dispatch('photoReports/editPhotoReport', {
                formData: this.formData,
                id: this.editedPhotoReport.id
            });

            this.closeEditDialog();
        },

        onFileSelect(file) {
            this.editedPhotoReport.csvFile = file;
        }
    }
};
</script>
